import type mapboxgl from 'mapbox-gl';
import type {MapMouseEvent} from 'react-map-gl/mapbox';

/*
Shared by every map component, and imported by the component harness specs —
keep this module free of runtime imports so it loads under node.
*/

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoibW1vdXRlbm90IiwiYSI6ImNrdjZ4bTJ5NTlkeDgzMWs2aGtycTBmdHMifQ.pdEn0wQf2_gFxCdMGPeCEg';

// Public Mapbox styles the app's maps draw from.
export const MAPBOX_STYLE_IDS = {
  light: 'light-v10',
  outdoors: 'outdoors-v12',
  satelliteStreets: 'satellite-streets-v12',
  streets: 'streets-v12',
} as const;

export function mapboxStyleUrl(styleId: string): string {
  return `mapbox://styles/mapbox/${styleId}`;
}

/*
react-map-gl attaches the hit-tested features for interactiveLayerIds onto the
event, but the mapbox-gl 3.3 typings for MapMouseEvent predate that field.
*/
export type InteractiveMouseEvent = MapMouseEvent & {
  features?: mapboxgl.MapboxGeoJSONFeature[];
};

/*
Site-page map heights, exported so the component harness exercises the values
the page really uses.
*/
export const SITE_MAP_HEIGHT_COLLAPSED = 288;
export const SITE_MAP_HEIGHT_EXPANDED = 600;
